export default [
	'text_block',
	'media_block'
]
